import Vue from "vue"
import Router from "vue-router"

// App
const AppContainer = () => import("@/containers/app");
const AppIndex = () => import("@/views/app/index");
// Policies
const PoliciesContainer = () => import("@/containers/policies");
const PoliciesPrivacy = () => import("@/views/policies/privacy")
// Error Page
const ErrorPageContainer = () => import("@/containers/error");

Vue.use(Router);

let vue = new Vue();

/* 路由列表 */
let router = new Router({
    mode: "history",
    base: process.env.VUE_APP_PUBLIC_PATH ? `/${process.env.VUE_APP_PUBLIC_PATH}` : '/',
    routes: [
        // App 
        {
            path: "/",
            name: "",
            component: AppContainer,
            redirect: "/",
            children: [
                {
                    path: "",
                    name: "首页",
                    component: AppIndex,
                }
            ]
        },
        // Policies 
        {
            path: "/policies",
            name: "隐私政策",
            component: PoliciesContainer,
            redirect: "/policies",
            children: [
                {
                    path: "/policies/:type/:appName/:version?",
                    name: "产品隐私政策",
                    component: PoliciesPrivacy,
                },
            ]
        },
        // Error Page
        {
            path: "/404",
            name: "404",
            component: ErrorPageContainer,
            meta: { "title": "404 Page Not Found", }
        },
        {
            path: "*",
            redirect: "/404"
        }
    ]
});

export default router
